import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-stone-200 last:border-0" data-id="element-173">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 rounded-lg px-2" onClick={onClick} aria-expanded={isOpen} data-id="element-174">
        <span className="text-lg font-bold text-stone-900" data-id="element-175">{question}</span>
        <ChevronDownIcon className={cn('w-5 h-5 text-stone-500 transition-transform duration-200 flex-shrink-0 ml-4', isOpen ? 'transform rotate-180' : '')} data-id="element-176" />
      </button>
      <div className={cn('overflow-hidden transition-all duration-300 ease-in-out px-2', isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0')} data-id="element-177">
        <p className="text-stone-600 text-lg" data-id="element-178">{answer}</p>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="bg-white rounded-2xl border border-stone-200 p-4 md:p-8 shadow-sm" data-id="element-179">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-180" />)}
    </div>;
}